// extracted by mini-css-extract-plugin
module.exports = {"modal":"FeedModal_modal__3R6YO"};